<template>
  <div class="mb-4">
    <v-row class="select-form pl-4 pr-3">
      <v-col :cols="windowInnerWidth > 800 ? 2 : 3">
        <h6 class="pt-2 pl-4" style="font-weight: bold;">{{ props.title }}</h6>
      </v-col>
      <v-col :cols="windowInnerWidth > 800 ? 6 : 9">
        <v-select
          class="small"
          v-model="modelValue"
          :items="items"
          density="compact"
          item-title="label"
          item-value="key"
          :clearable="false"
          v-bind="{'return-object': true}"
          :error-messages="props.errors"
        >
        </v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const emit = defineEmits(['update:modelValue'])

const props = defineProps<{
  modelValue: {
    key: number | string | null,
    label: string
  }
  title: string
  items: {
    key: string | number | boolean | null,
    label: string,
  }[]
  selectedItem: {
    key: string | number | boolean | null,
    label: string,
  }
  errors: string[],
  windowInnerWidth: number
}>()

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})
</script>
